import { ROLES } from "@ea/shared_types/types";
import { ROUTES } from "@app/routes";

export const getDefaultRoute = (userRoles: Array<string>) => {
  if (userRoles.length === 1 && userRoles.includes(ROLES.documentationReader)) {
    return ROUTES.documentation_tree;
  }
  return userRoles && userRoles.includes(ROLES.projects) ? ROUTES.projects : ROUTES.scripts;
};
